import { render, staticRenderFns } from "./EditingCriteriaDictionary.vue?vue&type=template&id=7ee728a1&"
import script from "./EditingCriteriaDictionary.vue?vue&type=script&lang=js&"
export * from "./EditingCriteriaDictionary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports